import { TrainingGoalSlug } from './types';

/**
 * Array of all top-level step slugs in the Program Generator flow.
 * These are used by the UI router to determine the current step index and navigation path.
 */
export const PROGRAM_GENERATOR_SLUGS = [
  'intro', // 1
  'client-selection', // 2
  'energy-level', // 3
  'non-gym-activity', // 4
  'fitness-level', // 5
  'movement-insights', // 6
  'injuries-limitations', // 7
  'intro-minipt', // 8
  'program-duration', // 9
  'training-schedule', // 10
  'workout-duration', // 11
  'training-goal', // 12
  'training-goal-details', // 13
  'secondary-training-goals', // 14
  'program-intensity', // 15
  'equipment', // 16
  'review', // 17
  'manual-program-name', // 18
];

/**
 * Array of slugs specifically used for the multiple "Movement Insights" screens.
 * This ensures the frontend accurately emits these sub-step slugs sequentially when saving to the store.
 */
export const MOVEMENT_INSIGHT_SLUGS = [
  'mobility-level',
  'stability-control',
  'balance-consistency',
  'movement-symmetry',
  'overall-movement-quality',
];

/**
 * Returns the sequence of sub-step slugs dynamically based on the selected training goal.
 * Different training goals (like Weight Loss or Rehabilitation) require entirely different
 * sets of follow-up questions from the master data.
 *
 * @param goal - The selected TrainingGoalSlug (e.g., 'weight-loss')
 * @returns Array of sub-step slugs for routing the UI
 */
export const getSubStepSlugs = (goal: string) => {
  if (goal === TrainingGoalSlug.WeightLoss) {
    return [
      'training-goal-details',
      'training-goal-preferences',
      'weight-loss-target',
      'training-goal-approaches',
    ];
  }
  if (goal === TrainingGoalSlug.Rehabilitation) {
    return ['training-goal-details', 'rehabilitation-stage', 'training-goal-approaches'];
  }
  if (goal === TrainingGoalSlug.Endurance || goal === TrainingGoalSlug.GeneralFitness) {
    return ['training-goal-details', 'training-goal-approaches'];
  }
  return ['training-goal-details', 'training-goal-preferences', 'training-goal-approaches'];
};

/**
 * Array of training approach slugs that mandate selecting at least one piece of equipment.
 */
export const EQUIPMENT_MANDATORY_APPROACHES = [
  'compound-strength-training',
  'powerlifting-focused',
  'strength-muscle-building',
  'full-body-hypertrophy',
  'upper-lower-split',
  'push-pull-legs',
  'body-part-split',
  'strength-based-fat-loss',
  'cardio-strength-mix',
  'strength-power',
  'strength-cardio-mix',
  'return-to-strength',
];
